export default class RpcBase{
    constructor() {
    }

    async getFkFieldLabel(fiendName) {

        if(!this[fiendName]){
            return "";
        }

        const [model, formConfig]  = this.detectModel();
        if(!model || !formConfig){
            return '';
        }

        let formFieldConfig = model.validatedFieldByName(fiendName)?.formFieldConfig;
        if(!formFieldConfig){
            return '';
        }

        return this.__getFkLabel(formFieldConfig.foreignClass, fiendName, true, formConfig.isDynamic);
    }

    getRemoteClass(){
        const [model, formConfig]  = this.detectModel();
        return formConfig?.formClassLong;
    }

    /** @returns {ExtendedPromise<*>}*/
    async getFkFieldEntity(fiendName) {
        if(!this[fiendName]){
            return null;
        }

        const [model, formConfig]  = this.detectModel();
        if(!model || !formConfig){
            return null;
        }

        let formFieldConfig = model.validatedFieldByName(fiendName)?.formFieldConfig;
        if(!formFieldConfig){
            return null;
        }

        return this.__getFkEntity(formFieldConfig.foreignClass, fiendName, true, formConfig.isDynamic);
    }

    /**
     *
     * @return {[FormModel, FormConfig]}
     */
    detectModel(){
        let model = this.__formModel__;
        if(!model && this.__form_id__){
            model = FormsLoader.detectFormConfig(this.__form_id__);
        }
        if(!model){
            model = FormsLoader.detectFormConfig(this, true);
        }

        return [model, model?.formConfig];
    }

    /** @returns {ExtendedPromise<String>} */
    getInstanceLabel() {
        return this.__supplement__?.label;
    }

    /** @returns {ExtendedPromise<String>} */
    __getFkLabel(targetClass, propName, allowRemote, isDynamic=false){
        if(this[propName] == null ||  this[propName] == undefined){
            return RpcClass.extendPromise(new Promise(r => r("")));
        }
        if(!this.__supplement__){
            this.__supplement__ = {fkLabels:{}};
        } else {
            if(this.__supplement__.fkLabels === undefined){
                this.__supplement__.fkLabels = {};
            }
        }

        if(this.__supplement__.fkLabels[propName] != null){
            let promise = new Promise( resolve => resolve(this.__supplement__.fkLabels[propName]));
            return RpcClass.extendPromise(promise);
        }
        if(!allowRemote){
            throw new Error(propName + " can't be read automatically");
        }

        let promise = window["Rpc"].Forms[isDynamic ? 'getDynamicEntityLabel' : 'getEntityLabel'](targetClass, this[propName]).then(label => {
            this.__supplement__.fkLabels[propName] = label;
            return label;
        });

        return RpcClass.extendPromise(promise);

    }

    /** @returns {ExtendedPromise<String>} */
    __getFkStaticLabel(targetClass, propName){
        if(this[propName] == null ||  this[propName] == undefined){
            return "";
        }
        if(!this.__supplement__){
            this.__supplement__ = {fkLabels:{}};
        } else {
            if(this.__supplement__.fkLabels === undefined){
                this.__supplement__.fkLabels = {};
            }
        }

        if(this.__supplement__.fkLabels[propName]){
            return this.__supplement__.fkLabels[propName];
        }

        return "...";
    }

    /** @returns {ExtendedPromise<BookStatusDict>} */
    __getFkEntity(targetClass, propName, allowRemote, isDynamic=false){
        if(this[propName] == null ||  this[propName] == undefined){
            return RpcClass.extendPromise(new Promise(r => r(null)));
        }

        if(!this.__supplement__){
            this.__supplement__ = {fkInstances:{}};
        } else {
            if(this.__supplement__.fkInstances === undefined){
                this.__supplement__.fkInstances = {};
            }
        }

        if(this.__supplement__.fkInstances[propName] !== undefined){

            let promise = new Promise( resolve => resolve(this.__supplement__.fkInstances[propName]));
            return RpcClass.extendPromise(promise);
        }
        if(!allowRemote){
            throw new Error(propName + " can't be read automatically");
        }

        let promise = window["Rpc"].Forms[isDynamic ? 'getDynamicEntity' : 'getEntity'](targetClass, this[propName]).then(inst => {
            this.__supplement__.fkInstances[propName] = inst;
            return inst;
        });

        return RpcClass.extendPromise(promise);
    }

    __save(fullClassName, fields){
        const procResults = (clone) => {
            for (let k in clone) {
                this[k] = clone[k];
            }
        }
        let promise;
        if(!this.id){
            promise = Rpc.Forms.addEntity(fullClassName, this).then(procResults);
        } else {
            if(!fields) {
                promise = Rpc.Forms.editEntity(fullClassName, this).then(procResults);
            } else {
                promise = Rpc.Forms.editEntityFields(fullClassName, this, fields).then(procResults);;
            }
        }

        return RpcClass.extendPromise(promise);
    }

    async refreshComputed(formConfig, region=null) {
        try {
            let form = FormsLoader.detectFormConfig(formConfig, true);
            if (form && !form.isView) {

                let newVal;
                // if(region == null || region == 'def'){
                    newVal = await Rpc.Forms.refreshComputedFields(form.formClassLong, this);
                // } else {
                // newVal = await Rpc.Forms.refreshComputedFieldsForRegion(form.formClassLong, this, region);
                // }
                if(newVal.__computed__){
                    this.__computed__ = newVal.__computed__;
                }
                if(newVal.__computed_links__){
                    this.__computed_links__ = newVal.__computed_links__;
                }
                if(newVal.__supplement__){
                    this.__supplement__ = newVal.__supplement__;
                }
                for(let f of form.fields){
                    if(f.computed){
                        this[f.fieldName] = newVal[f.fieldName];
                    }
                }
            }
        } catch (e){
            console.log(e);
        }
    }

    toJSON(){
        return _.omitBy(this, (v, /** string*/ k)=>k.startsWith("__"));
    };

}